import React, { useState, useEffect } from "react";
import { Grid, Typography, Box } from "@material-ui/core";
import ButtonAtom from "../../component/ButtonAtom/index.jsx";
import TextfieldAtom from "../../component/Textfield/index.jsx";
import { makeStyles } from "@material-ui/styles";
import firebase from "../../config/firebase/index";
import Otp_Verification from "../otp_verification/Otp_Verification";
import { useHistory, withRouter } from "react-router-dom";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CircularIndeterminate from './../../component/Loader/index';

import ReactGA from 'react-ga';
import { CircularProgress } from "@mui/material";
import encSecret from "../../config/encryption/index.js";
var CryptoJS = require("crypto-js");


const Login = () => {
  const history = useHistory();
  const [mynumber, setnumber] = useState("");
  const [show, setshow] = useState(false);
  const [final, setfinal] = useState("");
  const [mobileField, setMobileField] = useState(false);
  const [phoneFlag, setPhoneFlag] = useState(true);
  const [loading, setLoading] = useState(false);



  const phoneValidation = (category, action, label) => {
    console.log("GA event:", category, ":", action, ":", label);
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    })
  }

  const handleNumberChange = (e) => {
    if ((e.target.value).length === 0) {
      setPhoneFlag(true);
      setnumber(e.target.value);
      setMobileField(false);
      phoneValidation("Sign Up", "Validation", "Invalid/Blank Number");

    }
    else if ((e.target.value).length > 0 && ((e.target.value).length < 10 || (e.target.value).length > 10)) {
      setPhoneFlag(false);
      setnumber(e.target.value);
      setMobileField(false);
      phoneValidation("Sign Up", "Validation", "Invalid/Blank Number");

    }
    else if ((e.target.value).length === 10) {
      setnumber(e.target.value);
      setPhoneFlag(true);
      phoneValidation("Sign Up", "Value Inserted", "Phone number filled");
    }

  };

  const OtpTriggered = (category, action, label) => {
    console.log("GA event:", category, ":", action, ":", label);
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    })
  }

  useEffect(() => {
    localStorage.setItem("Phone Number", mynumber);

    // firebase.database().ref("Users").once("value", snapshot => {
    //   console.log(snapshot.val());
    //   const userData = snapshot.val();
    //   for (const key in userData) {
    //     const editRef = firebase.database().ref('Users/' + key);
    //     editRef.update({
    //       "Name": CryptoJS.AES.encrypt(userData[key].Name, encSecret.key).toString(),
    //     });
    //   }
    // });

  });
  // Sent OTP
  const signin = () => {

    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "invisible",
      }
    );
    const appVerifier = window.recaptchaVerifier;
    setLoading(true);
    firebase
      .auth()
      .signInWithPhoneNumber("+91" + mynumber, appVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        setshow(true);
        setLoading(false);
        setMobileField(true);
        OtpTriggered("Login", "Backend", "OTP sent");

      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };

  const classes = useStyles();
  return (

    <Grid className={classes.commonFullSection}>

      <Grid className={classes.commonMidSection} style={{ display: !show ? "block" : "none" }}>
        <Typography variant="h4" style={{ fontWeight: 600 }} gutterBottom className={classes.purpuleColor}>
          सौदेबाज़ी
        </Typography>

        <Box mt={4} mb={3}>
          <Typography variant="h7" gutterBottom style={{ fontWeight: 600 }} >
            फोन नंबर के साथ लॉग इन / साइन अप करें
          </Typography>
        </Box>

        <Box mb={3}>

          {/* <Typography variant="body" className={classes.labelAlign}>
              अपने फ़ोन नंबर से शुरू करे
            </Typography> */}
          <Typography variant="body" className={classes.labelAlign3} style={{ display: phoneFlag ? "block" : "none" }}>
            लॉग इन करने के लिए कृपया अपना फोन नंबर दर्ज करें।
          </Typography>

          <Typography variant="body" gutterBottom className={classes.labelAlign2} style={{ display: !phoneFlag ? "block" : "none" }}>
            कृपया सही मोबाइल नंबर दर्ज करें।
          </Typography>

          <Box className={classes.headerBrowser2}>
            <WhatsAppIcon className={classes.headerBrowser3} />
            <TextfieldAtom
              placeholder="अपना व्हाट्सप्प नंबर दर्ज करे"
              value={mynumber}
              type="number"
              inputMode="numeric"
              style={{ fontSize: '16px' }}
              disabled={mobileField}
              onChange={handleNumberChange}
            />
          </Box>

        </Box>
        <div id="recaptcha-container"></div>
        {loading ? <CircularProgress /> :
          <></>}
        <Box mb={3}>
          <ButtonAtom
            name="ओटीपी प्राप्त करे "
            disabled={!(mynumber && mynumber.length === 10)}
            onClick={() => { signin(); }}
          />
        </Box>
      </Grid>
      <Typography variant="caption" gutterBottom className={classes.marginTopAuto} style={{ display: !show ? "block" : "none" }}>
        किसी भी मदद के लिए 8696965308 पर कॉल करें
      </Typography>

      <Grid className={classes.commonFullSection} style={{ display: show ? "block" : "none" }}>
        <Otp_Verification sentOtp={final} number={mynumber} signin={signin} />
      </Grid>

    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  commonFullSection: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  commonMidSection: {
    maxWidth: 540,
    background: '#fff',
    // boxShadow: '0 0 5px #eee',
    padding: 20,
    textAlign: 'center',
    marginTop: 'auto',
    width: 'calc(100% - 60px)',
  },
  marginTopAuto: {
    marginTop: 'auto',
  },
  labelAlign: {
    textAlign: 'left',
    marginRight: '120px',
    marginTop: 34,
  },
  labelAlign2: {
    textAlign: 'left',
    marginRight: '80px',
    marginLeft: "20px",
    marginTop: 15,
  },
  labelAlign3: {
    textAlign: 'left',
    marginLeft: '20px',
    marginTop: 15,
    fontSize: '14px'
  },
  purpuleColor: {
    color: '#53252f',
  },
  headerBrowser2: {
    background: '#fff',
    color: 'black',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 20px',
    alignItems: 'center',
    position: 'relative',
    '& input': {
      paddingLeft: 50,
    }

  },
  headerBrowser3: {
    position: 'absolute',
    top: 25,
    left: 30,
    color: '#53252f',
  },
  inputMargin: {
    marginLeft: '20px',
    marginRight: '20px',
  }
}));

export default withRouter(Login);